import type { StateContext } from '@ngxs/store';
import type { MultiViewStateModel } from '../MultiViewStateModel';

export function getViewIndex(ctx: StateContext<MultiViewStateModel>, specificViewId?: string) {
  const state = ctx.getState();
  const viewIndex = state?.views.findIndex((v) => v.id === state?.currentViewId || v.id === specificViewId);
  return viewIndex;
}
export function getCurrentView(state: MultiViewStateModel) {
  const viewIndex = state?.views.find((v) => v.id === state.currentViewId);
  return viewIndex;
}
export function getViewIndexById(state: StateContext<MultiViewStateModel>, id: string) {
  const viewIndex = state.getState()?.views.findIndex((v) => v.id === id);
  return viewIndex;
}

export * from './anomalies.action-handler';
export * from './channel-handlers';
export * from './comment.action-handler';
export * from './control-handlers';
export * from './data.action-handler';
export * from './laneConfig.action-handler';
export * from './sensor-table.action-handler';
export * from './view.action-handler';
export * from './visualization-handlers';
